export default "__VITE_ASSET__BSvZJQpb__"